/* eslint-disable */
export default {
  cancel: 'Cancelar',
  close: 'Fechar',
  ok: 'OK',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
